// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yeU3v","field":"styles_field__3gZ8n","fieldCol":"styles_fieldCol__jNJx6","diffCol":"styles_diffCol__3Lsim","diff":"styles_diff__2k5st"};